import { ADD_ORG_DATA } from './actionTypes';

export function addOrgDataAction(orgData) {
  return (dispatch) => {
    dispatch({
      type: ADD_ORG_DATA,
      data: orgData,
    });
  };
}
